module.exports = __webpack_public_path__ + "static/media/backgroundImg.d5ca7f0d.jpg";